import { useEffect } from 'react';

/**
 * ONE definition of "this is a guest page".
 *
 * A guest tapped a card — they are a customer of the client, not a user of the
 * portal. So no portal title, no portal splash, no admin chrome, no Help Mode,
 * whatever happens to be in this device's localStorage.
 */
export const GUEST_ROUTE_RE = new RegExp(
    '^/(' + [
        'review-shield', 'review-shield-experience', 'landing', 'demo', 'global-review',
        'hotel', 'assistant', 'vehicle', 'm', 'staff', 'manager', 'tap-entry', 'grocery',
        'mytap', 'respond-now', 'bridge',
    ].join('|') + ')(/|$)',
);

export const isGuestRoute = (pathname = window.location.pathname) =>
    GUEST_ROUTE_RE.test(pathname || '');

/** Neutral until the client's own name is known — never the portal's name. */
export const NEUTRAL_TITLE = '\u00a0';

/** Called by a guest page once it knows whose business this is. */
export const setGuestTitle = (name) => {
    if (!isGuestRoute()) return;
    const clean = (name || '').toString().trim();
    document.title = clean || NEUTRAL_TITLE;
};

/** Keeps the tab title on the CLIENT's business name (never the portal's). */
export const useGuestTitle = (name) => {
    useEffect(() => { setGuestTitle(name); }, [name]);
};
